import { Modal } from 'bootstrap';

// general - FRAGEN JS
const eval_modal = document.getElementById('evalModal');

const check_btn = document.getElementById('check_btn');
const close_btn = document.querySelector('.btn-clinic-close');
const result_content = document.getElementById('result');

// buttons, radios
const quest_btns = document.querySelectorAll('.btn-question');
const quest_radios = document.querySelectorAll('.check-question');

function removeActiveButtons() {
  // remove all current active
  quest_btns.forEach(function (element) {
    element.classList.remove("active");
  });
}

if (eval_modal) {

  // form vars
  const loadUrl = '/'+document.documentElement.lang+'/'+document.documentElement.dataset.start+'/app/check/';

  const showModal = new Modal('#evalModal', {
    keyboard: false
  });

  // button functions
  let q_button_val = '';
  // loop through list elements
  if (quest_btns) {
    // add click event
    quest_btns.forEach(function (element) {
      element.addEventListener('click', function (e) {
        // remove current active
        removeActiveButtons();
        // add new active
        element.classList.add("active");
        // add value to var
        q_button_val = element.dataset.verify;
        // prüfen button remove disabeld
        if (check_btn.disabled) {
          check_btn.removeAttribute('disabled');
        }
      });
    });
  }

  if (quest_radios) {
    quest_radios.forEach(function (element) {
      element.addEventListener('change', function (e) {
        // add value
        q_button_val = element.value;
        // prüfen button remove disabeld
        if (check_btn.disabled) {
          check_btn.removeAttribute('disabled');
        }
      });
    });
  }

  if (check_btn) {
    // on click get result
    check_btn.addEventListener('click', function (e) {

      var a_val       = q_button_val;
      var frage_id    = check_btn.dataset.frage;
      var content_id  = check_btn.dataset.content;
      var output_id   = check_btn.dataset.output;
      var page        = check_btn.dataset.page;
      var total       = check_btn.dataset.total;
      var block       = check_btn.dataset.block;

      // empty current content
      result_content.innerHTML = '';

      // Prepare the form data
      const formData = new URLSearchParams({
        antwort: a_val,
        frage: parseInt(frage_id),
        content: parseInt(content_id),
        output: parseInt(output_id),
        page: parseInt(page),
        total: parseInt(total),
        qblock: parseInt(block)
      });

      fetch(loadUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: formData.toString()
      })
          .then(response => response.text())
          .then(dataHtml => {
            result_content.innerHTML = dataHtml;
            showModal.show(eval_modal);
          })
          .catch(error => {
            console.error('Error:', error);
          });
    });
  }

}